import { Brand } from "../types/domains";
import { combinedConfig } from "./combinedConfig";

export const brandsArray: Brand[] = [
  {
    name: "Lacoste",
    domains: [
      {
        name: "lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "shop-fr-staging.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "us.lacoste.com",
        unitSystem: "imperial",
        defaultBraSize: "US",
      },
      {
        name: "gb.lacoste.com",
        unitSystem: "imperial",
        defaultBraSize: "UK",
      },
      {
        name: "br.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "de.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "at.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "be.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "ch.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "dk.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "es.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "ie.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "it.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "nl.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "pt.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "se.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "kleep-internal.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.lacoste.config,
  },
  {
    name: "KENZO",
    domains: [
      {
        name: "kenzo.com",
        unitSystem: "metric",
        defaultBraSize: "FR",
      },
      {
        name: "www.kenzo.com",
        unitSystem: "metric",
        defaultBraSize: "FR",
      },
      {
        name: "stg.kenzo.com",
        unitSystem: "metric",
        defaultBraSize: "FR",
      },
      {
        name: "sb03.kenzo.com",
        unitSystem: "metric",
        defaultBraSize: "FR",
      },
      {
        name: "demo.kenzo.com",
        unitSystem: "metric",
        defaultBraSize: "FR",
      },
      {
        name: "dev.kenzo.com",
        unitSystem: "metric",
        defaultBraSize: "FR",
      },
    ],
    config: combinedConfig.kenzo.config,
  },
  {
    name: "Sporty & Rich",
    domains: [
      {
        name: "sportyandrich.com",
        unitSystem: "metric",
      },
      {
        name: "sporty-rich.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "dashboard-sporty-aed.kleep",
        unitSystem: "metric",
      },
      {
        name: "dashboard-sporty-aud.kleep",
        unitSystem: "metric",
      },
      {
        name: "dashboard-sporty-cad.kleep",
        unitSystem: "metric",
      },
      {
        name: "dashboard-sporty-uk.kleep",
        unitSystem: "metric",
        defaultBraSize: "UK",
      },
      {
        name: "dashboard-sporty-us.kleep",
        unitSystem: "metric",
        defaultBraSize: "US",
      },
      {
        name: "dashboard-sporty-world.kleep",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.sportyAndRich.config,
  },
  {
    name: "Place des Tendances",
    domains: [
      {
        name: "pldt-app",
        unitSystem: "metric",
      },
      {
        name: "placedestendances.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.placeDesTondances.config,
  },
  {
    name: "Le Slip Français",
    domains: [
      {
        name: "www.leslipfrancais.fr",
        unitSystem: "metric",
      },
      {
        name: "le-slip-francais-testing.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.leSlipFrancais.config,
  },
  {
    name: "IZAC",
    domains: [
      {
        name: "izac.fr",
        unitSystem: "metric",
      },
      {
        name: "izac.en",
        unitSystem: "metric",
      },
      {
        name: "izac.en",
        unitSystem: "metric",
      },
      {
        name: "izac-paris.com",
        unitSystem: "metric",
      },
      {
        name: "izac-shop.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.izac.config,
  },
  {
    name: "JOTT",
    domains: [
      {
        name: "jott.com",
        unitSystem: "metric",
      },
      {
        name: "justoverthetop.co.uk",
        unitSystem: "metric",
        defaultBraSize: "UK",
      },
      {
        name: "justoverthetop-testing.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.jott.config,
  },
  {
    name: "From Future",
    domains: [
      {
        name: "www.fromfuture.com",
        unitSystem: "metric",
      },
      {
        name: "de.fromfuture.com",
        unitSystem: "metric",
      },
      {
        name: "en.fromfuture.com",
        unitSystem: "metric",
      },
      {
        name: "it.fromfuture.com",
        unitSystem: "metric",
      },
      {
        name: "fromfuture-int.com",
        unitSystem: "metric",
      },
      {
        name: "fu-tu-re.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.fromFuture.config,
  },
  {
    name: "Circle SportsWear",
    domains: [
      {
        name: "circlesportswear.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.circleSportswear.config,
  },
  {
    name: "Rodier",
    domains: [
      {
        name: "www.rodier.fr",
        unitSystem: "metric",
      },
      {
        name: "preprod02-fo-rodier.wshop.cloud",
        unitSystem: "metric",
      },
      {
        name: "en.rodier.fr",
        unitSystem: "imperial",
        defaultBraSize: "UK",
      },
      {
        name: "preprod-fo.rodier-en.wshop.cloud",
        unitSystem: "imperial",
        defaultBraSize: "UK",
      },
      {
        name: "www.rodier.be",
        unitSystem: "metric",
      },
      {
        name: "www.rodier.at",
        unitSystem: "metric",
      },
      {
        name: "www.de-rodier.com",
        unitSystem: "metric",
      },
      {
        name: "www.rodier.nl",
        unitSystem: "metric",
      },
      {
        name: "www.rodier.pt",
        unitSystem: "metric",
      },
      {
        name: "www.rodier.es",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.rodier.config,
  },
  {
    name: "La Canadienne",
    domains: [
      {
        name: "la-canadienne.com",
        unitSystem: "metric",
      },
      {
        name: "la-canadienne-boutique.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "www.la-canadienne.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.laCanadienne.config,
  },
  {
    name: "Gerard Darel",
    domains: [
      {
        name: "gerarddarel.com",
        unitSystem: "metric",
      },
      {
        name: "darel-pablo-development.vercel.app",
        unitSystem: "metric",
      },
      {
        name: "gerard-darel.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "gerard-darel-development.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "gerard-darel-git-feat-kleep-widget-darel-pablo.vercel.app",
        unitSystem: "metric",
      },
      {
        name: "gerarddarel.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.gerardDarel.config,
  },
  {
    name: "Ron Dorff",
    domains: [
      {
        name: "rondorff.com",
        unitSystem: "metric",
      },
      {
        name: "uk.rondorff.com",
        unitSystem: "metric",
      },
      {
        name: "us.rondorff.com",
        unitSystem: "metric",
      },
      {
        name: "preprod-rondorff.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "ron-dorff-store.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.ronDorff.config,
  },
  {
    name: "The Kooples",
    domains: [
      {
        name: "thekooples.com",
        unitSystem: "metric",
      },
      {
        name: "dev.thekooples.com",
        unitSystem: "metric",
      },
      {
        name: "stg.thekooples.com",
        unitSystem: "metric",
      },
      {
        name: "staging.thekooples.com",
        unitSystem: "metric",
      },
      {
        name: "www.thekooples.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.theKooples.config,
  },
  {
    name: "Chlore",
    domains: [
      {
        name: "www.chlore-swimwear.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.chlore.config,
  },
  {
    name: "Molli",
    domains: [
      {
        name: "www.molli.com",
        unitSystem: "metric",
      },
      {
        name: "molli.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.molli.config,
  },
  {
    name: "Place du Jour",
    domains: [
      {
        name: "placedujour.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.placeDuJour.config,
  },
  {
    name: "Gualap",
    domains: [
      {
        name: "gualap.com",
        unitSystem: "metric",
      },
      {
        name: "gualap.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.gualap.config,
  },
  {
    name: "Vogstore",
    domains: [
      {
        name: "vogstoree.com",
        unitSystem: "metric",
      },
      {
        name: "vog-store.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.vogstore.config,
  },
  {
    name: "SRP",
    domains: [
      {
        name: "showroomprive.com",
        unitSystem: "metric",
      },
      {
        name: "fr-v4.terone.showroomprive.net",
        unitSystem: "metric",
      },
      {
        name: "saldiprivati.com",
        unitSystem: "metric",
      },
      {
        name: "showroomprive.es",
        unitSystem: "metric",
      },
      {
        name: "showroomprive.pt",
        unitSystem: "metric",
      },
      {
        name: "showroomprive.be",
        unitSystem: "metric",
      },
      {
        name: "showroomprive.nl",
        unitSystem: "metric",
      },
      {
        name: "showroomprive.ma",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.srp.config,
  },
  {
    name: "Hartford",
    domains: [
      {
        name: "hartford.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.hartford.config,
  },
  {
    name: "La Petite Etoile",
    domains: [
      {
        name: "www.lapetiteetoile.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.laPetiteEtoile.config,
  },
  {
    name: "Mister K",
    domains: [
      {
        name: "misterk.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.misterK.config,
  },
  {
    name: "Petrone",
    domains: [
      {
        name: "petroneparis.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.petrone.config,
  },
  {
    name: "Zadig & Voltaire",
    domains: [
      {
        name: "zadig-et-voltaire.com",
        unitSystem: "metric",
      },
      {
        name: "preprod.eu.z-v.cloud",
        unitSystem: "metric",
      },
      {
        name: "www.polaris.preprod.eu.z-v.cloud",
        unitSystem: "metric",
      },
      {
        name: "www.jupiter.eu.z-v.cloud",
        unitSystem: "metric",
      },
      {
        name: "www.venus.eu.z-v.cloud",
        unitSystem: "metric",
      },
      {
        name: "www.saturne.eu.z-v.cloud",
        unitSystem: "metric",
      },
      {
        name: "www.neptune.eu.z-v.cloud",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.zadigVoltaire.config,
  },
  {
    name: "Bensimon",
    domains: [
      {
        name: "bensimon.com",
        unitSystem: "metric",
      },
      {
        name: "preprod-fo.bensimon.wshop.cloud",
        unitSystem: "metric",
      },
      {
        name: "en.bensimon.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.bensimon.config,
  },
  {
    name: "Stella & Suzie",
    domains: [
      {
        name: "stellaetsuzie.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.stellaSuzie.config,
  },
  {
    name: "Antonelle",
    domains: [
      {
        name: "antonelle.fr",
        unitSystem: "metric",
      },
      {
        name: "antonellefr.preprod123.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.antonelle.config,
  },
  {
    name: "Une Jour Ailleurs",
    domains: [
      {
        name: "unjourailleurs.com",
        unitSystem: "metric",
      },
      {
        name: "unjourailleurscom.preprod123.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.uneJourAilleurs.config,
  },
  {
    name: "Kookai",
    domains: [
      {
        name: "kookai.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.kookai.config,
  },
  {
    name: "Asphalte",
    domains: [
      {
        name: "asphalte.com",
        unitSystem: "metric",
      },
      {
        name: "fr.asphalte.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.asphalte.config,
  },
  {
    name: "Soeur",
    domains: [
      {
        name: "www.soeur.fr",
        unitSystem: "metric",
        defaultBraSize: "FR",
      },
      {
        name: "us.soeur.fr",
        unitSystem: "imperial",
        defaultBraSize: "US",
      },
      {
        name: "www.soeur.uk",
        unitSystem: "imperial",
        defaultBraSize: "UK",
      },
      {
        name: "www.soeur.kr",
        unitSystem: "imperial",
        defaultBraSize: "UK",
      },
    ],
    config: combinedConfig.soeur.config,
  },
  {
    name: "Et Paris",
    domains: [
      {
        name: "etparis.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.etParis.config,
  },
  {
    name: "Faguo",
    domains: [
      {
        name: "faguo-store.com",
        unitSystem: "metric",
      },
      {
        name: "faguo-dev01.sidemo.fr",
        unitSystem: "metric",
      },
      {
        name: "preprod01.faguo-store.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.faguo.config,
  },
  {
    name: "Project X Paris",
    domains: [
      {
        name: "www.projectxparis.com",
        unitSystem: "metric",
      },
      {
        name: "project-x-paris-shop.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.projectXParis.config,
  },
  {
    name: "Hast",
    domains: [
      {
        name: "hastparis.com",
        unitSystem: "metric",
      },
      {
        name: "www.hastparis.com",
        unitSystem: "metric",
      },
      {
        name: "hast-2023.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.hast.config,
  },
  {
    name: "SAAJ",
    domains: [
      {
        name: "saajparis.fr",
        unitSystem: "metric",
      },
      {
        name: "saajparis.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.saaj.config,
  },
  {
    name: "Bonne Gueule",
    domains: [
      {
        name: "bonnegueule.fr",
        unitSystem: "metric",
      },
      {
        name: "bonnegueule-shop.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.bonneGueule.config,
  },
  {
    name: "Devred",
    domains: [
      {
        name: "devred.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.devred.config,
  },
  {
    name: "Theodore",
    domains: [
      {
        name: "theodore.ae",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.theodore.config,
  },
  {
    name: "LTDC",
    domains: [
      {
        name: "letempsdescerises.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.ltdc.config,
  },
  {
    name: "Nina Ricci",
    domains: [
      {
        name: "www.ninaricci.com",
        unitSystem: "metric",
      },
      {
        name: "ninaricci-development-eur.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "nina-ricci-staging.vercel.app",
        unitSystem: "metric",
      },
      {
        name: "ninaricci-global.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.ninaRicci.config,
  },
  {
    name: "Maison Kitsuné",
    domains: [
      {
        name: "maisonkitsune.com",
        unitSystem: "metric",
      },
      {
        name: "preprod-m2.maisonkitsune.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.maisonKitsune.config,
  },
  {
    name: "Victoria Beckham",
    domains: [
      {
        name: "victoriabeckham.com",
        unitSystem: "metric",
      },
      {
        name: "www.victoriabeckham.com",
        unitSystem: "imperial",
        defaultBraSize: "UK",
      },
      {
        name: "victoria-beckham-uk.myshopify.com",
        unitSystem: "imperial",
      },
      {
        name: "international.victoriabeckham.com",
        unitSystem: "metric",
        defaultBraSize: "EU",
      },
      {
        name: "victoria-beckham-international.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "us.victoriabeckham.com",
        unitSystem: "imperial",
        defaultBraSize: "US",
      },
      {
        name: "victoria-beckham-us.myshopify.com",
        unitSystem: "imperial",
      },
    ],
    config: combinedConfig.victoriaBeckham.config,
  },
  {
    name: "Rabanne",
    domains: [
      {
        name: "rabanne.com",
        unitSystem: "metric",
      },
      {
        name: "www.rabanne.com",
        unitSystem: "metric",
      },
      {
        name: "fashion.rabanne.com",
        unitSystem: "metric",
      },
      {
        name: "paco-rabanne-france.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "paco-rabanne-staging.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.rabanne.config,
  },
  {
    name: "Weill",
    domains: [
      {
        name: "www.weill.com",
        unitSystem: "metric",
      },
      {
        name: "weill-paris.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.weill.config,
  },
  {
    name: "Sud Express",
    domains: [
      {
        name: "www.sudexpress.fr",
        unitSystem: "metric",
      },
      {
        name: "www.sudexpress.com",
        unitSystem: "metric",
      },
      {
        name: "sudexpress.com",
        unitSystem: "metric",
      },
      {
        name: "sudexpress-prod.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.sudExpress.config,
  },
  {
    name: "Loom",
    domains: [
      {
        name: "www.loom.fr",
        unitSystem: "metric",
      },
      {
        name: "loom-fr.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.loom.config,
  },
  {
    name: "Alme",
    domains: [
      {
        name: "www.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "de.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "it.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "gb.almeparis.com",
        unitSystem: "imperial",
      },
      {
        name: "es.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "pt.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "nl.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "se.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "ch.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "fi.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "dk.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "pl.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "at.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "almeparis.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.alme.config,
  },
  {
    name: "Sport 2000",
    domains: [
      {
        name: "www.sport2000.fr",
        unitSystem: "metric",
      },
      {
        name: "sport2000.fr",
        unitSystem: "metric",
      },
      {
        name: "ecom.sport2000.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.sport2000.config,
  },
  {
    name: "Loro Piana",
    domains: [
      {
        name: "fr.loropiana.com",
        unitSystem: "metric",
      },
      {
        name: "demo.kleep.ai",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.loropiana.config,
  },
  {
    name: "Givenchy",
    domains: [
      {
        name: "www.givenchy.com",
        unitSystem: "metric",
      },
      {
        name: "development.givenchy.com",
        unitSystem: "metric",
      },
      {
        name: "bbrt-002.dx.commercecloud.salesforce.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.givenchy.config,
  },
  {
    name: "Ogier",
    domains: [
      {
        name: "ogier-og.com",
        unitSystem: "metric",
      },
      {
        name: "www.ogier-og.com",
        unitSystem: "metric",
      },
      {
        name: "xdxupq-zp.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "ogierstore.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "ogier1948.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.ogier.config,
  },
  {
    name: "Loulou de Saison",
    domains: [
      {
        name: "louloudesaison.com",
        unitSystem: "metric",
      },
      {
        name: "www.louloudesaison.com",
        unitSystem: "metric",
      },
      {
        name: "louloudesaison.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.louloudeSaison.config,
  },
  {
    name: "Eric Bompard",
    domains: [
      {
        name: "eric-bompard.com",
        unitSystem: "metric",
      },
      {
        name: "www.eric-bompard.com",
        unitSystem: "metric",
      },
      {
        name: "ericbompard.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "ericbompard-development.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.ericBompard.config,
  },
  {
    name: "Intersport",
    domains: [
      {
        name: "intersport.fr",
        unitSystem: "metric",
      },
      {
        name: "preprod-hybris.intersport.fr",
        unitSystem: "metric",
      },
      {
        name: "mock-is",
        unitSystem: "metric",
      },
      {
        name: "mock-is-int",
        unitSystem: "metric",
      },
      {
        name: "mock-is-pp",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.intersport.config,
  },
  {
    name: "Blackstore",
    domains: [
      {
        name: "blackstore.fr",
        unitSystem: "metric",
      },
      {
        name: "www.blackstore.fr",
        unitSystem: "metric",
      },
      {
        name: "mock-bs-int",
        unitSystem: "metric",
      },
      {
        name: "mock-bs-pp",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.blackstore.config,
  },
  {
    name: "Vanessa WU",
    domains: [
      {
        name: "vanessawu.com",
        unitSystem: "metric",
      },
      {
        name: "vanessa-wu.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "vanessa-wu-dev.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.vanessawu.config,
  },
  {
    name: "Bonpoint",
    domains: [
      {
        name: "www.bonpoint.com",
        unitSystem: "metric",
      },
      {
        name: "us.bonpoint.com",
        unitSystem: "imperial",
        defaultBraSize: "US",
      },
      {
        name: "uk.bonpoint.com",
        unitSystem: "imperial",
        defaultBraSize: "UK",
      },
      {
        name: "bonpoint-eu.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "bonpoint-uk.myshopify.com",
        unitSystem: "imperial",
        defaultBraSize: "UK",
      },
      {
        name: "bonpoint-us.myshopify.com",
        unitSystem: "imperial",
        defaultBraSize: "US",
      },
      {
        name: "www.uk.bonpoint.com",
        unitSystem: "imperial",
        defaultBraSize: "UK",
      },
      {
        name: "www.us.bonpoint.com",
        unitSystem: "imperial",
        defaultBraSize: "US",
      },
    ],
    config: combinedConfig.bonpoint.config,
  },
  {
    name: "Paprika",
    domains: [
      {
        name: "www.paprika.fr",
        unitSystem: "metric",
        defaultBraSize: "FR",
      },
      {
        name: "www.paprika-shopping.be",
        unitSystem: "metric",
        defaultBraSize: "EU",
      },
      {
        name: "www.paprika-shopping.de",
        unitSystem: "metric",
        defaultBraSize: "EU",
      },
      {
        name: "www.paprika-shopping.nl",
        unitSystem: "metric",
        defaultBraSize: "EU",
      },
      {
        name: "cassispaprika-dev.myshopify.com",
        unitSystem: "metric",
        defaultBraSize: "EU",
      },
      {
        name: "cassispaprika-prod.myshopify.com",
        unitSystem: "metric",
        defaultBraSize: "EU",
      },
    ],
    config: combinedConfig.paprika.config,
  },
  {
    name: "Fedeli Cashmere",
    domains: [
      {
        name: "fedelicashmere.com",
        unitSystem: "metric",
      },
      {
        name: "www.fedelicashmere.com",
        unitSystem: "metric",
      },
      {
        name: "fedelicashmere.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.fedelicashmere.config,
  },
  {
    name: "Pyrenex",
    domains: [
      {
        name: "pyrenex.com",
        unitSystem: "metric",
      },
      {
        name: "pyrenex-shop.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.pyrenex.config,
  },
  {
    name: "Club Brugge",
    domains: [
      {
        name: "shop.clubbrugge.be",
        unitSystem: "metric",
      },
      {
        name: "staging-club-brugge-shop.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "club-brugge-shop.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "www.shop.clubbrugge.be",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.brugge.config,
  },
  {
    name: "LeCollet",
    domains: [
      {
        name: "lecollet.pl",
        unitSystem: "metric",
      },
      {
        name: "www.lecollet.pl",
        unitSystem: "metric",
      },
      {
        name: "lecollet.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.lecollet.config,
  },
  {
    name: "Velour Garments",
    domains: [
      {
        name: "velourgarments.eu",
        unitSystem: "metric",
      },
      {
        name: "velour-garments.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.velourGarments.config,
  },
  {
    name: "Peserico",
    domains: [
      {
        name: "eu.peserico.com",
        unitSystem: "metric",
      },
      {
        name: "us.peserico.com",
        unitSystem: "metric",
      },
      {
        name: "it.peserico.com",
        unitSystem: "metric",
      },
      {
        name: "peserico-us.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "peserico-eu.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.peserico.config,
  },
  {
    name: "Culto",
    domains: [
      {
        name: "culto.fit",
        unitSystem: "metric",
        defaultBraSize: "US",
      },
      {
        name: "www.culto.fit",
        unitSystem: "metric",
      },
      {
        name: "cultoapparel.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.culto.config,
  },
  {
    name: "No Gender",
    domains: [
      {
        name: "nogender.eu",
        unitSystem: "metric",
      },
      {
        name: "www.nogender.eu",
        unitSystem: "metric",
      },
      {
        name: "nogender-clothing.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.noGender.config,
  },
  {
    name: "Barnie",
    domains: [
      {
        name: "barnie.com",
        unitSystem: "metric",
      },
      {
        name: "www.barnie.com",
        unitSystem: "metric",
      },
      {
        name: "les-cocottes-pimp-ton-style.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.barnie.config,
  },
  {
    name: "Millet",
    domains: [
      {
        name: "www.millet.com",
        unitSystem: "metric",
      },
      {
        name: "millet.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.millet.config,
  },
  {
    name: "TDF",
    domains: [
      {
        name: "www.thedoublef.com",
        unitSystem: "metric",
      },
      {
        name: "thedoublef.com",
        unitSystem: "metric",
      },
      {
        name: "thedoublef-com.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "thedoublef-prod.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "vip-tdf.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "vip-tdf.com",
        unitSystem: "metric",
      },
      {
        name: "www.vip-tdf.com",
        unitSystem: "metric",
      },
      {
        name: "vip.thedoublef.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.tdf.config,
  },
  {
    name: "Marcy Paris",
    domains: [
      {
        name: "marcy.paris",
        unitSystem: "metric",
      },
      {
        name: "getkleep-marcy-paris.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.marcyParis.config,
  },
  {
    name: "Curling",
    domains: [
      {
        name: "www.curling.fr",
        unitSystem: "metric",
      },
      {
        name: "curlingparis.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.curling.config,
  },
  {
    name: "Devernois",
    domains: [
      {
        name: "www.devernois.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.devernois.config,
  },
  {
    name: "Atelier Tuffery",
    domains: [
      {
        name: "www.ateliertuffery.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.ateliertuffery.config,
  },
  {
    name: "BESSEC",
    domains: [
      {
        name: "www.bessec-chaussures.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.bessec.config,
  },
  {
    name: "Bash",
    domains: [
      {
        name: "ba-sh.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.bash.config,
  },
  {
    name: "The Nines",
    domains: [
      {
        name: "www.thenines.fr",
        unitSystem: "metric",
      },
      {
        name: "thenines.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.thenines.config,
  },
  {
    name: "BZB",
    domains: [
      {
        name: "www.b-z-b.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.bzb.config,
  },
  {
    name: "Jules",
    domains: [
      {
        name: "www.jules.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.jules.config,
  },
  {
    name: "Celio",
    domains: [
      {
        name: "www.celio.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.celio.config,
  },
  {
    name: "Barbara Bui",
    domains: [
      {
        name: "barbarabui.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.barbarabui.config,
  },
  {
    name: "Ancient Greek Sandals",
    domains: [
      {
        name: "www.ancient-greek-sandals.com",
        unitSystem: "metric",
      },
      {
        name: "ancient-greek-sandals-store.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.ancientGreekSandals.config,
  },
  {
    name: "Salt Murphy",
    domains: [
      {
        name: "saltmurphy.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.saltmurphy.config,
  },
  {
    name: "Yuxus",
    domains: [
      {
        name: "www.yuxus.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.yuxus.config,
  },
  {
    name: "Marjolaine",
    domains: [
      {
        name: "www.marjolaine.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.marjolaine.config,
  },
  {
    name: "Sessun",
    domains: [
      {
        name: "fr.sessun.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.sessun.config,
  },
  {
    name: "Freeman",
    domains: [
      {
        name: "www.freemantporter.com",
        unitSystem: "metric",
      },
      {
        name: "freemantporter.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.freemantporter.config,
  },
  {
    name: "Etam",
    domains: [
      {
        name: "www.etam.com",
        unitSystem: "metric",
      },
      {
        name: "etam.com",
        unitSystem: "metric",
      },
      {
        name: "8e499103-cc87-444d-a103-f28bcabc4188",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.etam.config,
  },
  {
    name: "Sans Complexe",
    domains: [
      {
        name: "www.sanscomplexe.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.sanscomplexe.config,
  },
  {
    name: "Simone Pérèle",
    domains: [
      {
        name: "fr.simone-perele.com",
        unitSystem: "metric",
      },
      {
        name: "simone-perele-fr-prd.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "simone-perele-be-prd.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "simone-perele-uk-prd.myshopify.com",
        unitSystem: "imperial",
        defaultBraSize: "UK",
      },
      {
        name: "simone-perele-int-prd.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.simonePerele.config,
  },
  {
    name: "Cimalp",
    domains: [
      {
        name: "www.cimalp.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.cimalp.config,
  },
  {
    name: "Galore",
    domains: [
      {
        name: "galoreyyz.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.galoreyyz.config,
  },
];
